module.exports = __webpack_public_path__ + "static/media/banner-text-mobile.71363532.png";